<template>
  <div :class="this.$style.wrapper">
    <img :class="this.$style.gif" src="/static/images/loading-screen-dark.gif" alt="Room" />
  </div>
</template>
<script>
export default {
  mounted() {
    console.log("mounted dat loader");
  }
};
</script>

<style lang='scss' module>
@import "../assets/css/globals.scss";
.wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: $greenHouse;
  z-index: 800;

  transition: all linear 0.3s;
}
.gif {
  position: relative;
  left: 50%;
  // probably could pass in the height of ServPro header
  // so it'd be a prop or watched property that sets
  // top to `calc(50% + this.headerHeight)
  // top: calc(50% + 8vh);
  top: 50%;
  max-width: 200px;

  @include large {
    max-width: 300px;
  }

  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/Loader.vue